import { createFileRoute } from '@tanstack/react-router'

import { NewWorkflowPage } from '@/pages/new-workflow/NewWorkflow.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/workbench/new',
)({
  component: NewWorkflowPage,
})
